import { ThemeDefinition } from 'vuetify';

export const base: ThemeDefinition = {
  dark: false,
  colors: {
    brand: '#005eb8',
    'on-brand': '#ffffff',
    'brand-original': '#005eb8',
    'on-brand-original': '#ffffff',
    accent: '#db335d',
    'on-accent': '#ffffff',
    'accent-original': '#ea5373',
    'on-accent-original': '#ffffff',
    primary: '#004c94',
    'on-primary': '#ffffff',
    'primary-container': '#b2daff',
    'on-primary-container': '#00203d',
    secondary: '#3e5a74',
    'on-secondary': '#ffffff',
    'secondary-container': '#cdd9e4',
    'on-secondary-container': '#151f28',
    tertiary: '#a91e3c',
    'on-tertiary': '#ffffff',
    'tertiary-container': '#f7bbc8',
    'on-tertiary-container': '#340912',
    error: '#A32929',
    'on-error': '#FFFFFF',
    'error-container': '#F1C6C6',
    'on-error-container': '#3D0F0F',
    background: '#e8edf3',
    surface: '#f8fafb',
    'on-surface': '#1d1f20',
    'on-surface-medium': '#55595e',
    'on-surface-low': '#94999e',
    outline: '#7a8085',
    'outline-variant': '#c9cccf',
    shadow: '#000000',
    scrim: '#000000',
    'inverse-surface': '#303235',
    'inverse-on-surface': '#fafafa',
    'inverse-primary': '#b2daff',
    'primary-fixed': '#b2daff',
    'on-primary-fixed': '#00203d',
    'primary-fixed-dim': '#70baff',
    'on-primary-fixed-variant': '#004F99',
    'secondary-fixed': '#cdd9e4',
    'on-secondary-fixed': '#151f28',
    'secondary-fixed-dim': '#9fb6cb',
    'on-secondary-fixed-variant': '#364D63',
    'tertiary-fixed': '#f7bbc8',
    'on-tertiary-fixed': '#340912',
    'tertiary-fixed-dim': '#f297aa',
    'on-tertiary-fixed-variant': '#257466',
    'surface-dim': '#cad7e2',
    'surface-bright': '#fbfcfd',
    'surface-container-lowest': '#ffffff',
    'surface-container-low': '#f2f5f8',
    'surface-container': '#e8edf3',
    'surface-container-high': '#dee6ed',
    'surface-container-highest': '#d7e1ea',
  },
};

export const baseDark: ThemeDefinition = {
  dark: true,
  colors: {
    brand: '#80bdf4',
    'on-brand': '#00203d',
    'brand-original': '#005eb8',
    'on-brand-original': '#f5faff',
    accent: '#f39bae',
    'on-accent': '#340912',
    'accent-original': '#ea5373',
    'on-accent-original': '#fef6f8',
    primary: '#a8d5ff',
    'on-primary': '#00203d',
    'primary-container': '#004f99',
    'on-primary-container': '#f5faff',
    secondary: '#c3d2df',
    'on-secondary': '#151f28',
    'secondary-container': '#364d63',
    'on-secondary-container': '#f8fafb',
    tertiary: '#eec4cf',
    'on-tertiary': '#340914',
    'tertiary-container': '#821732',
    'on-tertiary-container': '#fdf6f8',
    error: '#E8A1A1',
    'on-error': '#3D0F0F',
    'error-container': '#8F2424',
    'on-error-container': '#FAEBEB',
    background: '#111518',
    surface: '#111518',
    'on-surface': '#f2f2f3',
    'on-surface-medium': '#c9cccf',
    'on-surface-low': '#798086',
    outline: '#94999e',
    'outline-variant': '#61666b',
    shadow: '#000000',
    scrim: '#000000',
    'inverse-surface': '#e4e6e7',
    'inverse-on-surface': '#1d1f20',
    'inverse-primary': '#00468a',
    'primary-fixed': '#b2daff',
    'on-primary-fixed': '#00203d',
    'primary-fixed-dim': '#70baff',
    'on-primary-fixed-variant': '#004F99',
    'secondary-fixed': '#cdd9e4',
    'on-secondary-fixed': '#151f28',
    'secondary-fixed-dim': '#9fb6cb',
    'on-secondary-fixed-variant': '#364D63',
    'tertiary-fixed': '#f7bbc8',
    'on-tertiary-fixed': '#340912',
    'tertiary-fixed-dim': '#f297aa',
    'on-tertiary-fixed-variant': '#257466',
    'surface-dim': '#0f1215',
    'surface-bright': '#323b43',
    'surface-container-lowest': '#0d1012',
    'surface-container-low': '#161a1d',
    'surface-container': '#1c2125',
    'surface-container-high': '#252c32',
    'surface-container-highest': '#303841',
  },
};
